define('container/argResolvers/ParamArgResolver',['underscore', 'bluebird'], function(_, Promise) {

    'use strict';

    function ParamArgResolver() {
    }

    ParamArgResolver.prototype.canResolveArg = function(argDefinition) {
        return argDefinition.substring(0, 1) === '%';
    };

    ParamArgResolver.prototype.resolveArg = function(argDefinition, extensionApi) {
        return Promise.resolve(
            _.reduce(
                argDefinition.substring(1).split('.'),
                function(current, key) {
                    return current[key];
                },
                extensionApi.container.config.params
            )
        );
    };

    return ParamArgResolver;
});

